import debounce from 'lodash.debounce'

/**
 * echarts resize 在window resize时自动调用
 */
export default {
  data () {
    this.$_resizeHandler = null
    return {}
  },

  mounted () {
    this.$_initListener()
  },

  activated () {
    // 防止重复监听
    if (!this.$_resizeHandler) {
      this.$_initListener()
    }
    // 当组件 keep-alive activated resize
    this.$_resize()
  },

  deactivated () {
    // 当组件 keep-alive deactivated 时取消监听
    this.$_destroyListener()
  },

  beforeDestroy () {
    this.$_destroyListener()
  },

  methods: {
    /** 监听 resize */
    $_initListener () {
      this.$_resizeHandler = debounce(() => {
        this.$_resize()
      }, 100)
      window.addEventListener('resize', this.$_resizeHandler)
    },
    /** 取消监听 resize */
    $_destroyListener () {
      window.removeEventListener('resize', this.$_resizeHandler)
      this.$_resizeHandler = null
    },
    /** echarts resize */
    $_resize () {
      if (!this.chart || typeof this.chart.resize !== 'function') return
      this.chart.resize()
    }
  }
}
